import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {RouterLink, RouterOutlet} from '@angular/router';
import {Backend} from '@generated-backend-types';
import {HeaderComponent} from '../components/header/header.component';
import {SidebarComponent} from '../components/sidebar/sidebar.component';
import {AppVersionService} from '../services/api/app-version.service';
import {UserSessionService} from '../services/user-session.service';
import AuthenticatedUser = Backend.App.Resources.Dashboard.Auth.AuthenticatedUser;
import AppVersion = Backend.App.Resources.AppVersion;

@Component({
  selector: 'app-authenticated',
  templateUrl: './authenticated.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    RouterLink,
    HeaderComponent,
    SidebarComponent
  ]
})
export class AuthenticatedComponent implements OnInit, AfterViewInit {
  isCollapsed = true;
  public user?: Partial<AuthenticatedUser>;
  public currentYear = (new Date()).getUTCFullYear();
  public appVersion?: AppVersion;

  public constructor(
    public userSessionService: UserSessionService,
    private readonly cdr: ChangeDetectorRef,
    private appVersionService: AppVersionService,
  ) {}

  public headerHeight() {
    return document.getElementById('header-height')?.scrollHeight
  }

  public ngOnInit() {
    this.appVersionService.getVersion().subscribe(version => {
      this.appVersion = version;
      this.cdr.markForCheck();
    });
  }

  public ngAfterViewInit() {
    this.userSessionService.user$.subscribe(value => this.user = value ?? undefined);
  }
}
